import { render, staticRenderFns } from "./banner-cookies-v2.vue?vue&type=template&id=99d4b034&"
import script from "./banner-cookies-v2.vue?vue&type=script&lang=js&"
export * from "./banner-cookies-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d4b034')) {
      api.createRecord('99d4b034', component.options)
    } else {
      api.reload('99d4b034', component.options)
    }
    module.hot.accept("./banner-cookies-v2.vue?vue&type=template&id=99d4b034&", function () {
      api.rerender('99d4b034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/banner-cookies-v2.vue"
export default component.exports